import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';
import Navbar from './components/Navbar';
import LoadingSpinner from './components/LoadingSpinner';
import StarfieldBackground from './components/StarfieldBackground';

// Lazy load pages
const Dashboard = lazy(() => import('./components/Dashboard'));
const Login = lazy(() => import('./components/Auth/Login'));
const Register = lazy(() => import('./components/Auth/Register'));
const QuickCheck = lazy(() => import('./components/QuickCheck/QuickCheck'));
const TimeSlotOptimizer = lazy(() => import('./components/TimeSlotOptimizer/TimeSlotOptimizer'));
const NowcastView = lazy(() => import('./components/Nowcast/NowcastView'));
const RouteRiskMapper = lazy(() => import('./components/RouteRisk/RouteRiskMapper'));
const EventScheduler = lazy(() => import('./components/Events/EventScheduler'));
const Profile = lazy(() => import('./components/Profile/Profile'));

function App() {
  const { currentUser, loading } = useAuth();

  if (loading) {
    return <LoadingSpinner fullScreen />;
  }

  return (
    <Router>
      <div className="min-h-screen relative overflow-hidden">
        <StarfieldBackground />
        
        <div className="relative z-10 pb-8">
          <Navbar />
          
          <Suspense fallback={<LoadingSpinner fullScreen />}>
            <Routes>
              {/* Public routes */}
              <Route path="/login" element={!currentUser ? <Login /> : <Navigate to="/" />} />
              <Route path="/register" element={!currentUser ? <Register /> : <Navigate to="/" />} />
              
              {/* Protected routes */}
              <Route 
                path="/" 
                element={currentUser ? <Dashboard /> : <Navigate to="/login" />} 
              />
              <Route 
                path="/quick-check" 
                element={currentUser ? <QuickCheck /> : <Navigate to="/login" />} 
              />
              <Route 
                path="/optimizer" 
                element={currentUser ? <TimeSlotOptimizer /> : <Navigate to="/login" />} 
              />
              <Route 
                path="/nowcast" 
                element={currentUser ? <NowcastView /> : <Navigate to="/login" />} 
              />
              <Route 
                path="/route-risk" 
                element={currentUser ? <RouteRiskMapper /> : <Navigate to="/login" />} 
              />
              <Route 
                path="/events" 
                element={currentUser ? <EventScheduler /> : <Navigate to="/login" />} 
              />
              <Route 
                path="/profile" 
                element={currentUser ? <Profile /> : <Navigate to="/login" />} 
              />
            </Routes>
          </Suspense>
        </div>
      </div>
    </Router>
  );
}

export default App;
